module.exports = __webpack_public_path__ + "static/media/resetPoints.c73fe7fa.png";